/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from 'react';
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID} from '../../configs/const';
import { DOMAINDISPLAY } from '../../configs/apkFileName';
let oid = OPERATOR_ID.toLowerCase()


export default class PrivacyPolicy extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    
    render() {
        return (
            <>
           <section className='sportbook-livecasino'>                
                <div className="subpage-head1">
                    <div className="subpage-head1__image">
                        <img alt="Offers Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/offers-banner.jpg"} />
                    </div> 
                    <div className="subpage-head1__content">
                        <h1 className="subpage-head1__title">Privacy Policy</h1>
                    </div>
                </div>
            </section>
                <div className="container mt-5">
                    <div className="row">
                       <div className='col-12'>
                            {/* <p className='section-head__title text-center text-uppercase termsbox'>Privacy Policy</p> */}
                        </div>
                       
                        <div className='col-12 loginrulesbox'>
                        <p className='loginrulestitle font-bold'>This Privacy Policy sets out:</p>
                        <ul className="rulesul">
                            <li>General information</li>
                            <li>Contact us</li>
                            <li>Data we collect</li>
                            <li>How we use your data</li>
                            <li>Who we share your data with</li>
                            <li>How we store your data</li>
                            <li>Your rights</li>
                        </ul>
                        <p className='loginrulestitle font-bold'>General information</p>
                        <p className='loginrulestitle '>{DOMAINDISPLAY.name} is managed by {DOMAINDISPLAY.name} Limited (hereinafter referred to as {DOMAINDISPLAY.name}). {DOMAINDISPLAY.name} is committed to
protecting and respecting your privacy and ensuring your security when you use our Services.
This Privacy Policy is to help you understand what we do with your data and how we protect and
process it.
</p>
                        <p className='loginrulestitle font-bold'>Contact us</p>
                        <p className='loginrulestitle'>{DOMAINDISPLAY.name} Limited is a data controller based in Malta. Our registered address is: 9 Empire Stadium
Street, Gzira, GZR 1300, Malta<br></br>
If you have any questions regarding your personal data please contact our Data Protection
Officer at <a href="mailto:DataProtectionOfficer@1xbook.com">DataProtectionOfficer@1xbook.com.</a> If you want to submit a request, please refer to
the ‘Your Rights’ section below.
</p>
                        <p className='loginrulestitle font-bold'>Data we collect</p>
                        
                        <p className='loginrulestitle'>During the registration process and when you subsequently use your {DOMAINDISPLAY.name} account, you are
requested to submit specific personal data including but not limited to:</p> 
                        <ul className="rulesul">
                            <li>your first and last name,</li>
                            <li>date of birth,</li>
                            <li>credit card or other payment data,</li>
                            <li>home or another physical address,</li>
                            <li>e-mail address,</li>
                            <li>phone/mobile number,</li>
                            <li>other contact data,</li>
                            <li>your unique user name and password combination for your account.</li>
                        </ul>
                        <p className='loginrulestitle '>Once you have created an account and have become a {DOMAINDISPLAY.name} customer, additional information
is processed on an on-going basis. {DOMAINDISPLAY.name} may also collect</p>
                    <ul className="rulesul">
                            <li>a record of all internet communications and details of your visits to our Websites;</li>
                            <li>technical information relating to how you use our products, such as the type of device
you are using and the browser you are using to access our Websites;</li>
                            <li>payment information and details of transactions you carry out through the site,
including your payment, withdrawals and wagers;</li>
                            <li>communications with us or our employees, for examples, calls, emails, and messages
sent through the live chat service;</li>
                            <li>information regarding your location, including IP address and traffic information;
</li>
                            <li>any additional information you submit through the website for example on forums,
chat rooms, comment sections or in response to quizzes and questionnaires;
</li>
                            <li>pages that you visited including what you have clicked on. Please see the Cookie
Policy below for more information;.
</li>
                            <li>Sometimes we may also request photo ID, proof of address, and source of funds;</li>
                            <li>Occasionally we may also access your public records (eg.: news articles, social media,
forums, official records such as the electoral roll).</li>
                        </ul>
                        <p className='loginrulestitle '>To protect both you and us, we use Services provided by third parties to help us decide whether
to accept transactions from you by assessing your method of payment, and the devices you use
to visit our Websites. These third-party services check whether the device or method of payment
has been identified with fraudulent or abusive transactions in the past, such as reported
instances of identity theft, promotion abuse or credit card fraud.</p>

<p className='loginrulestitle font-bold'>How we use your personal data</p>
<p className='loginrulestitle '>We use your personal data to try and provide you with the ultimate {DOMAINDISPLAY.name} experience whilst
ensuring we meet regulatory requirements, legal obligations and business related requirements.
We process your personal data for the purposes of:</p>

                            <ul className="rulesul">
                                <li>Creating your account and providing you with gambling services;</li>
                            </ul>
            <p className='loginrulestitle '>We use your personal data such as your name, DOB and email address to help set up your
account and, if necessary, to contact you (according to your preferences) via your registered
contact information in connection with the management and operation of your account.
We also use your personal data such as your device type, location and browser preferences to
manage your account. We want to ensure that you can see the best version of {DOMAINDISPLAY.name} on your
device and are authorised to use {DOMAINDISPLAY.name} in your current location. We do this based on our legal
obligations and legitimate interests to provide you services.</p>
                <ul className="rulesul">
                                <li>Ensuring our Websites function correctly and identifying any technical issues;</li>
                            </ul>

                            <p className='loginrulestitle '>As we want to give our customers the ultimate {DOMAINDISPLAY.name} experience, we may also use your
personal data that we collect using cookies and other similar technologies (“cookies”) to protect
our Website, offer you a personalised experience with us, tailor our marketing services and
improve our Website and the services you request through login, including banking. For more
information about the cookies we use and how to manage your cookie preferences please see
our <span className='font-bold'>Cookie Policy.</span>
</p>
                <ul className="rulesul">
                                <li>Ensuring you <span className='font-bold'>gamble responsibly</span></li>
                            </ul>

                            <p className='loginrulestitle '>{DOMAINDISPLAY.name} is committed to ensuring that you gamble responsibly. So, to abide by legal obligations
we will process your data to provide you with a safe environment to gamble, as well as to monitor
you for potential at-risk behaviour
</p>
                <ul className="rulesul">
                                <li>Identifying and verifying customers;</li>
                            </ul>

                            <p className='loginrulestitle '>This includes the identification and verification of individuals under anti-money laundering
legislation, ensuring customers are over 18 and to comply with responsible gambling rules and
initiatives. To verify your age and the details that you registered your account with, we may
disclose such information to approved third parties with many safeguards in place. This is
required to meet our legal obligations.

</p>
                <ul className="rulesul">
                                <li>Legal and regulatory obligations;</li>
                            </ul>
                            <p className='loginrulestitle '>We are required to process and retain your personal data including but not limited to your name,
account number, date of birth and location to prevent fraudulent activity, to detect and/or
investigate crimes, and to ensure responsible gambling. Additionally, we may also process your
personal data to meet our internal and external reporting requirements. This is required to meet
our legal obligations</p>

<p className='loginrulestitle '>Depending on your marketing preferences, we will use your personal data to send you
information by the contact methods you authorise us to use about our brands, products,
competitions, prizes and offers for the purpose of marketing {DOMAINDISPLAY.name}'s Services to you.
</p>

<p className='loginrulestitle '>You can choose not to receive marketing/promotional material at any time by managing your
marketing preferences via My Account. We also provide you with the opportunity to opt out by
reply in every marketing message we send.</p>

<p className='loginrulestitle '>If you have opted out of receiving marketing communications from us, we will take all reasonable
steps to ensure you no longer receive promotional material about {DOMAINDISPLAY.name}. We may however still
send you transactional emails, relating to the maintenance of, and changes to, your account.</p>

<p className='loginrulestitle '>The information we send you about bonuses, promotions and markets is based on our legitimate
interest.</p>

    <ul className="rulesul">
        <li>Prevention of crime;</li>
    </ul>

    <p className='loginrulestitle '>{DOMAINDISPLAY.name} has various policies and procedures designed to detect and prevent criminal activity. This
includes fraud detection and our Anti-Money Laundering programme. We carry out this
processing to comply with our legal obligations.</p>

    <ul className="rulesul">
        <li>Processing your online financial and wagering transactions;</li>
    </ul>

    <p className='loginrulestitle '>We need to use your personal data such as your account details, payment type(s), deposit
method(s) and wager history to allow you to deposit and withdraw, and for our regulatory
reporting. This is to comply with our Terms and Conditions and legal obligations.</p>

    <ul className="rulesul">
        <li>Profiling and your preferences;</li>
    </ul>

    <p className='loginrulestitle '>{DOMAINDISPLAY.name} will create new personal data about you by processing your data including but not limited
to your betting and gameplay behaviour, interests, location and age to develop new features,
functionality, products and services that are tailored to you. This will help us to ensure that:
</p>

    <ul className="rulesul">
        <li>The technical help you may need is in line with the device that you use, and</li>
        <li>The promotions you receive are in line with your preferences, and</li>
        <li>The customer support you receive is in line with your jurisdiction.</li>
    </ul>

    <p className='loginrulestitle '>Additionally, {DOMAINDISPLAY.name} researches your preferences to develop new features, functionality, products
and services. This is in our legitimate interests. Additionally, this profiling is in our legal interests,
as profiling of your personal data is for reasons such as meeting our legal requirements with
regards to anti-money laundering, age verification, prevention of fraud, sports integrity and
responsible gambling.

</p>

    <ul className="rulesul">
        <li>Risk management;</li>
    </ul>

    <p className='loginrulestitle '>We review customer profile and betting data for the purposes of enforcing our terms and
conditions managing our financial liabilities and risk on events and markets. For more information
please see section 7 of the General Terms and Conditions. This is both to comply with our
legitimate interest and legal obligations</p>
<p className='loginrulestitle'>Certain trusted third party companies provide services essential to our ability to offer our
gambling products to you, for example those that supply the software and games for our
Websites, banking and payment services, identity verification, fraud prevention and risk
management. We may be required to share some of your information with these companies,
some of which may be based outside the European Economic Area (EEA), to be able to offer our
Services to you. In these instances, we ensure that the third party has appropriate security and
privacy arrangements in place, so that your data is protected.h</p>
<p className='loginrulestitle '>{DOMAINDISPLAY.name} may also be required to disclose your information to government authorities, such as the
police or our regulators, to comply with our legal obligations. Personal information may also be
shared with regulators, agencies or relevant sports bodies where there are suspicions of
involvement in match-fixing or breach of sports regulations. We will also disclose information as
required to enforce our terms of use as stated in the <span className='font-bold'>Terms and Conditions</span>.</p>
<p className='loginrulestitle'>In the event of the sale of our business, or other business event, which results in us having to
transfer your personal data to a third party, you will be notified via email, or notice posted on our
website, to explain the identity of the new data controller and your options regarding your
personal data.
</p>
<p className='loginrulestitle'>Our site may contain links to and from the Websites of third party organisations. Please note that
these Websites may have their own privacy policies and that we do not accept any responsibility
whatsoever for these policies. Please check these policies carefully before you submit any
personal data
</p>
<p className='loginrulestitle font-bold'>How we store your personal data</p>
<p className='loginrulestitle'>{DOMAINDISPLAY.name} is incorporated in Malta and your data is stored within the European Economic Area
(“EEA”) on our servers. But where we work with third parties, the data we collect from you may be
transferred to, and stored at, a destination outside the EEA. It may also be processed by staff
operating outside the EEA who work for us or for one of our suppliers. Such staff may be
engaged in, among other things, customer services, the processing of your payment details and
risk/fraud management.</p>
<p className='loginrulestitle'>We ensure there are appropriate contractual controls over any third party that helps us process
your data, ensuring that your rights are upheld and your data is secure.
</p>
<p className='loginrulestitle'>We store your data for as long as you are an active customer with us. Once you are no longer our
customer, we will hold your personal data on our systems for as long as is necessary to comply
with our legal obligations in your jurisdiction, such those imposed by tax, gambling and AML laws.
</p>
<p className='loginrulestitle font-bold'>Changes to this policy</p>
<p className='loginrulestitle'>We reserve the right to change this Privacy Policy at any time, so please re-visit this page
frequently. We will provide notice of substantial changes of this Privacy Policy and will send you a
notice or an email regarding such changes. Otherwise, all other changes to this Privacy Policy are
effective as of the stated “Last updated” date, and your continued use of the Services after the
Last Revised date will constitute acceptance of, and agreement to be bound by, those changes</p>

                                   </div>
                    </div>
                </div>
                
            </>
        )
    }
}
